module.exports = __webpack_public_path__ + "img/LogoHorizontal.db88fad1.webp";